import _ from 'lodash'
import moment from 'moment'

const _REGEX_DATE = new RegExp(/\d{4}-[0-1]\d-[0-3]\d/)
const _REGEX_TIME = new RegExp(/[0-2]\d:[0-5]\d/)
const _REGEX_SECONDS = new RegExp(/[0-2]\d:[0-5]\d:[0-5]\d/)

const _DATE_FORMATS = ['DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm:ss']
const _DATE_FORMATS_SHORT = ['DD-MM-YYYY', 'DD-MM-YY', 'D-M-YYYY', 'D-M-YY']
const _TIMEZONE = 'Europe/Berlin'

const _REGEX_ISO8601 = new RegExp(
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/
)
const _REGEX_HASTIME = new RegExp(/[0-2]\d:[0-5]\d/)
const _REGEX_HASSECONDS = new RegExp(/[0-2]\d:[0-5]\d:[0-5]\d/)

const _parse = (date, time) => {
  const now = moment()
  const isISO8601 = _REGEX_ISO8601.test(date)
  const hasTime = _REGEX_HASTIME.test(date)
  const hasSeconds = _REGEX_HASSECONDS.test(date)

  // const isDate = _.isDate(date)
  // const isString = _.isString(date)
  // console.log('parse date', isDate, isString, date)

  // parse first with date formats from config
  // this represents the date format for the user interface
  let mf = moment(date, _DATE_FORMATS, true)
  if (mf.isValid()) {
    // convert moment to local datetime
    mf = toLocalDatetime(mf)
  }

  // parse with format option to prevent console errors
  // keep time
  if (!mf.isValid()) {
    // NOTE can be complete 2018-12-21T18:00:00+01:00 or incomplete 2018-12-21
    mf = moment(date, moment.ISO_8601, true)
    // we only convert an incomplete ISO8601 datetime
    if (!isISO8601) {
      mf = toLocalDatetime(mf)
    }
  }

  // parse at least with short formats for convenience
  // set time to 00:00 for from or 23:59 for to
  if (!mf.isValid()) {
    mf = moment(date, _DATE_FORMATS_SHORT, true)
    mf = toLocalDatetime(mf)
  }

  // valid moment created, convert to utc and format
  if (mf.isValid()) {
    // this.setSeconds()
  }

  return mf

  // string to parse is an user input in his timezone
  // convert moment to local date time
  function toLocalDatetime(m) {
    if (!m.isValid()) return m

    // create time setter
    // restore time from string to parse
    // or use time from now
    const settime = {
      hour: hasTime ? m.get('hour') : now.get('hour'),
      minute: hasTime ? m.get('minute') : now.get('minute'),
      second: hasSeconds ? m.get('second') : now.get('second'),
      millisecond: now.get('millisecond')
    }

    // no time in string to parse
    // and the time option is a from or to
    if (!hasTime) {
      if (time === 'from') {
        settime.hour = 0
        settime.minute = 0
        settime.second = 0
        settime.millisecond = 0
      } else if (time === 'to') {
        settime.hour = 23
        settime.minute = 59
        settime.second = 59
        settime.millisecond = 999
      }
    }
    // hasTime
    // => 16:28 -> from: 16:28:00.000
    // => 16:28 ->   to: 16:28:59.999
    else {
      if (time === 'from') {
        if (!hasSeconds) settime.second = 0
        settime.millisecond = 0
      } else if (time === 'to') {
        if (!hasSeconds) settime.second = 59
        settime.millisecond = 999
      }
    }

    // if (this.debug) console.log('settime', settime)
    // convert moment to local datetime
    return moment(m).set(settime)
    // return moment(m).tz(tz).set(settime)
  }

  // set min second for from
  // set max second for to
  function setSeconds(mf) {
    if (time === 'from') {
      mf.second(0).millisecond(0)
    } else if (time === 'to') {
      mf.second(59).millisecond(999)
    }
  }
}

const DateParser = {
  parse(date, options) {
    if (_.isNull(date) || _.isUndefined(date)) return date

    options = options || {}
    _.defaults(options, {utc: false, timezone: _TIMEZONE, strict: false})

    date = date.replace(/\./g, '-')

    let mom
    try {
      mom = !options.strict ? moment(date) : moment(date, 'YYYY-MM-DD', true)
    }
    catch (e) {
      // console.log('catch', e)
    }

    // strict mode, return result without other tries
    if (options.strict) return mom && mom.isValid() ? mom : void 0

    if (!mom || !mom.isValid()) {
      mom = _parse(date, options.time)
    }

    if (!mom || !mom.isValid()) {
      mom = moment(date)
    }

    if (mom && mom.isValid()) {
      if (options.utc) mom.utc()
      if (options.timezone && _.isFunction(mom.tz)) mom.tz(options.timezone)
      if (options.startOf) mom.startOf(options.startOf)
      if (options.endOf) mom.endOf(options.endOf)
    }

    // if (!mom.isValid()) console.log('mom invalid!', mom, date, options)
    return mom && mom.isValid() ? mom : void 0
  },

  format(date, format, options) {
    if (_.isNull(date)) return date

    if (_.isObject(format)) {
      options = format
      format = ''
    }
    const mom = this.parse(date, options)
    return mom ? mom.format(format) : ''
  }
}

const Intervals = {
  DAYS: 'days',
  D: 'd',
  WEEKS: 'weeks',
  W: 'w',
  MONTHS: 'months',
  M: 'm',
  YEARS: 'years',
  Y: 'y',
  /**
   * Test whether a given value is a valid permission
   * @param {string} value - check if value is a valid permission
   * @return {boolean} is valid or not
   */
  isValid: (value) => Object.keys(Intervals).some((_) => Intervals[_] === value)
}
const _DEFAULT_INTERVAL = Intervals.M

const _RETURN_VALUES = ['keys', 'start', 'end', 'duration', 'strings']

function Ranger(args) {
  // TODO from, to
  // TODO [from, to]
  // TODO ISO_8601 duration
  let unit = args.shift()
  let range

  // as two args -> "m", [from, to]
  if (_.isString(unit) && Intervals.isValid(unit)) {
    range = args.shift()
  }
  else {
    // as JSON object {unit: 'm', range: [from, to]}
    if (_.isObject(unit) && (_.has(unit, 'unit') || _.has(unit, 'range'))) {
      range = unit.range
      unit = unit.unit || _DEFAULT_INTERVAL
    }
    // as Array or String (only range)
    else {
      if (unit) range = _.isArray(unit) ? unit : [unit]
      unit = _DEFAULT_INTERVAL
    }
  }

  this.unit = unit
  this.range = range

  if (!_.isEmpty(range)) {
    this.start = this.parse(range[0])
    this.end = this.parse(range[1], true)
    this.duration = this.getDuration(this.start, this.end)
  }

  if (
    this.start &&
    this.duration.asMonths() < 1 &&
    (this.unit === 'm' || this.unit === 'y')
  ) {
    this.unit = Intervals.D
  }

  this.keys = this.build()
  this.strings = this.getStrings()
}

/**
 * Create range array for interval.
 * @return {string[]} list of ranges with key, gte and lte properties
 */
Ranger.prototype.build = function() {
  if (_.isEmpty(this.range)) {
    // console.warn('no range defined!')
    return []
  }

  const { unit, duration } = this
  const ir = []
  const mom = moment(this.start)
  if (!mom.isValid()) {
    console.warn('invalid ranger start!')
    return []
  }

  let key
  let gte
  let lte

  if (unit === Intervals.D) {
    let daysCount = Math.ceil(duration.asDays())
    _.times(daysCount, () => {
      key = mom.format('YYYY-MM-DD')
      gte = mom.startOf('day').format()
      lte = mom.endOf('day').format()
      mom.add(1, 'd')
      ir.push({ key, gte, lte })
    })
  }
  // r0 must be YYYY or YYYY-WW
  else if (unit === Intervals.W) {
    let weeksCount = Math.ceil(duration.asWeeks())
    // mom.subtract(weeksCount - 1, 'w')
    if (mom.isValid()) {
      _.times(weeksCount, () => {
        key = mom.format('YYYY-WW')
        gte = mom.startOf('week').format()
        lte = mom.endOf('week').format()
        mom.add(1, 'w')
        ir.push({ key, gte, lte })
      })
    }
  }
  // r0 must be YYYY or YYYY-MM
  else if (unit === Intervals.M) {
    // get number of months from diff between r1 und r0
    let monthsCount = Math.ceil(duration.asMonths())
    if (mom.isValid()) {
      _.times(monthsCount, () => {
        key = mom.format('YYYY-MM')
        // check if range is only a partial month
        gte = mom.startOf('month').isBefore(this.start)
          ? this.start.format()
          : mom.startOf('month').format()
        lte = mom.endOf('month').isAfter(this.end)
          ? this.end.format()
          : mom.endOf('month').format()
        mom.add(1, 'M')
        ir.push({ key, gte, lte })
      })
    }
  } else if (unit === Intervals.Y) {
    let yearsCount = Math.ceil(duration.asYears())
    // mom.subtract(yearsCount - 1, 'y')
    if (mom.isValid()) {
      _.times(yearsCount, () => {
        key = mom.format('YYYY')
        gte = mom.startOf('year').format()
        lte = mom.endOf('year').format()
        mom.add(1, 'y')
        ir.push({ key, gte, lte })
      })
    }
  }

  return ir
}

/**
 * Parse interval value.
 * @param {string?} dte - YYYY or YYYY-MM or YYYY-MM-DD
 * @param {boolean?} [endOf=false] calc end of interval
 * @return {Object} {year, month, date} default current year, month and date
 */
Ranger.prototype.parse = function(dte, endOf = false) {
  let mom = moment()
  let year = mom.year()
  let month = mom.month()
  let match
  let subtract = false
  let unit = ''
  let duration = 0

  if (dte && _.isString(dte)) {
    if (/^(now)/i.test(dte)) {
      match = dte.replace(/^(now)/i, '').trim()
      if (match[0] === '-') {
        subtract = true
        match = match.substr(1)
      }
      if (match) {
        unit = match.substr(-1)
        duration = parseInt(match.substr(0, match.length - 1), 10)
        subtract ? mom.subtract(duration, unit) : mom.add(duration, unit)
        endOf ? mom.endOf(unit) : mom.startOf(unit)
      }
    }
    else {
      mom = moment(dte)
      // console.log('m valid?', mom.isValid(), mom.format())
      if (!mom.isValid()) {
        match = dte.match(/\d{4}-\d{2}-\d{2}/)
        if (match) {
          mom = moment(dte, 'YYYY-MM-DD')
          endOf ? mom.endOf('day') : mom.startOf('day')
        }
        else {
          match = dte.match(/\d{4}-\d{2}/)
          if (match) {
            const ym = match[0].split('-')
            year = parseInt(ym[0], 10)
            month = parseInt(ym[1], 10) - 1 // NOTE with moment month starts with 0
          }
          else if (dte.match(/\d{4}/)) {
            year = parseInt(dte, 10)
            month = 0
          }
          mom = moment().year(year).month(month)
          endOf ? mom.endOf('month') : mom.startOf('month')
        }
      }
    }
  }

  return mom
}

Ranger.prototype.getDuration = function(from, to) {
  return moment.duration(to.diff(from))
}

Ranger.prototype.getStrings = function() {
  if (!this.start && !this.end) return {}

  const from = this.start.format('YYYY-MM-DD')
  const to = this.end.format('YYYY-MM-DD')

  const _locale = this.duration._locale
  const _relativeTime = _locale.relativeTime.bind(_locale)

  const _hum = new Array(4).fill('')
  const _humt = new Array(3).fill('')
  const _iso = new Array(4).fill('')
  const _isot = new Array(3).fill('')

  _.each(this.duration._data, (_d, _k) => {
    if (_d) {
      switch (_k) {
        case 'years':
          _hum[0] = _relativeTime(_d, true, 'yy')
          _iso[0] = _d + 'Y'
          break
        case 'months':
          _hum[1] = _relativeTime(_d, true, 'MM')
          _iso[1] = _d + 'M'
          break
        case 'days':
          _hum[2] = _relativeTime(_d, true, 'dd')
          _iso[2] = _d + 'D'
          break
        case 'hours':
          _humt[0] = _relativeTime(_d, true, 'hh')
          _isot[0] = _d + 'H'
          break
        case 'minutes':
          _humt[1] = _relativeTime(_d, true, 'mm')
          _isot[1] = _d + 'm'
          break
      }
    }
  })
  const humanize = _hum.join(' ')
  const humanizeTime = _humt.join(' ')
  const isoDuration = 'P' + _iso.join('')
  const isoDurationTime = 'T' + _isot.join('')
  return {
    isoDuration,
    isoDurationTime,
    humanize,
    humanizeTime,
    range: `[${from}, ${to}]`
  }
}

// expose wrapper methods for Ranger Class
const ranger = {
  create() {
    const inst = new Ranger(_.toArray(arguments))
    return _.pick(inst, _RETURN_VALUES)
  },

  // TODO set option to calc from start or end
  duration(range, durationIso) {
    const [start, end] = range
    const smom = moment(start)
    const sdur = moment.duration(durationIso)
    return [start, smom.add(sdur).format()]
  },

  analyze(range) {
    const gte = moment(range.gte)
    const lte = moment(range.lte)
    const sof = moment(range.gte).startOf('month')
    const eof = moment(range.lte).endOf('month')
    const part = lte.diff(gte)
    const full = eof.diff(sof)
    // console.log('gte, lte', lte.diff(gte), gte.format(), lte.format())
    // console.log('diff', eof.diff(sof), sof.format(), eof.format())
    // console.log('part, full', part, full)
    // console.log(range, moment.duration(part).asDays(), sof.daysInMonth())
    return {
      days: Math.round(moment.duration(part).asDays()),
      selected: Math.round((part * 100) / full)
    }
  },

  parseDate(date, strict) {
    const pm = DateParser.parse(date, {strict})
    if (!pm || !pm.isValid()) return

    // console.log('date', date, date.match(_REGEX_DATE))
    // console.log('parseDate', date, pm.format('YYYY-MM-DD'))
    return {
      year: pm.year(),
      month: pm.month(),
      date: pm.date()
    }
  },
  parseTime(time) {
    if (!time || !time.match(_REGEX_TIME)) return // always strict matching

    const now = moment()
    const m = moment(now.format('YYYY-MM-DD') + ' ' + time)
    return {
      hour: m.hour(),
      minute: m.minute(),
      second: m.second(),
      value: m.format('HH:mm')
    }
  }
}

export default ranger
